import DocumentPicker from './document-picker';

export default DocumentPicker;
